import { SourceType } from "../enums/SDKSourceType";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DesignComponentOrigin {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model, sources, rawSourceData) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        this.sourceId = (_a = model.sourceId) !== null && _a !== void 0 ? _a : null;
        this.id = (_b = model.id) !== null && _b !== void 0 ? _b : null;
        this.nodeId = (_c = model.nodeId) !== null && _c !== void 0 ? _c : null;
        this.name = (_d = model.name) !== null && _d !== void 0 ? _d : null;
        this.fileId = null;
        this.fileName = null;
        if (rawSourceData) {
            this.sourceType = rawSourceData.sourceType;
            this.fileId = rawSourceData.fileId;
            this.fileName = rawSourceData.fileName;
        }
        else if (model.sourceId) {
            const remoteSource = sources.filter((s) => s.id === model.sourceId)[0];
            if (remoteSource) {
                this.sourceType = remoteSource.type;
                this.fileId = (_f = (_e = remoteSource.cloud) === null || _e === void 0 ? void 0 : _e.fileId) !== null && _f !== void 0 ? _f : null;
                this.fileName = (_g = remoteSource.fileName) !== null && _g !== void 0 ? _g : null;
            }
        }
        this.width = (_h = model.width) !== null && _h !== void 0 ? _h : null;
        this.height = (_j = model.height) !== null && _j !== void 0 ? _j : null;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Conveniences
    get remoteDesignComponentUrl() {
        var _a;
        if (this.sourceType === SourceType.figma && this.fileId && this.nodeId) {
            return `https://www.figma.com/file/${this.fileId}/${(_a = this.fileName) !== null && _a !== void 0 ? _a : "unknown"}?node-id=${this.nodeId}`;
        }
        return undefined;
    }
    /** Constructs representation that can be used to transport the instantiated object as JSON */
    toTransport() {
        return {
            sourceType: this.sourceType,
            sourceId: this.sourceId,
            fileId: this.fileId,
            fileName: this.fileName,
            id: this.id,
            nodeId: this.nodeId,
            name: this.name,
            width: this.width,
            height: this.height,
        };
    }
    static fromTransport(transport) {
        var _a, _b, _c, _d, _e, _f;
        return new DesignComponentOrigin({
            id: (_a = transport.id) !== null && _a !== void 0 ? _a : "",
            sourceId: (_b = transport.sourceId) !== null && _b !== void 0 ? _b : "",
            nodeId: (_c = transport.nodeId) !== null && _c !== void 0 ? _c : "",
            name: (_d = transport.name) !== null && _d !== void 0 ? _d : "",
            width: (_e = transport.width) !== null && _e !== void 0 ? _e : undefined,
            height: (_f = transport.height) !== null && _f !== void 0 ? _f : undefined,
        }, [], transport);
    }
}
